import React from "react";
import { easeIn, easeInOut, motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

// icons
import { MdOutlineDarkMode } from "react-icons/md";
import { MdOutlineLightMode } from "react-icons/md";

const themeToggleVariants = {
	tap: {
		scale: 0.5,
	},
};

const ThemeToggler = () => {
	const { theme, setTheme, handleTheme } = useTheme();

	return (
		<>
			<motion.button
				variants={themeToggleVariants}
				whileTap="tap"
				className={`p-2 text-xl lg:text-3xl rounded-2xl ${
					theme === "dark"
						? "hover:bg-white hover:text-black"
						: "hover:bg-black hover:text-white"
				} transition-all duration-500 ease-linear`}
				onClick={
					theme === "dark"
						? () => handleTheme("light")
						: () => handleTheme("dark")
				}>
				{theme === "dark" ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
			</motion.button>
		</>
	);
};

export default ThemeToggler;
